var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.fetching,"icon":""},on:{"click":_vm.refeshEvents}},[_c('v-icon',[_vm._v("mdi-refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }